import type { VerticalTextSeparatorProps } from './VerticalTextSeparator.types'

export const VerticalTextSeparator = ({
  className,
}: VerticalTextSeparatorProps): JSX.Element => {
  return (
    <span className={className ?? ''} style={{ margin: '0 5px' }}>
      |
    </span>
  )
}
